export default class Accordion {
  boundToggleItem: (e: Event) => void;

  accordionButtons: NodeListOf<HTMLAnchorElement>;
  accordionButtonsLength: number;

  /**
   * Set scope, bind functions and get elements
   */
  constructor(scope: HTMLBodyElement) {
    // This binding is necessary to make `this` work in the callback
    this.boundToggleItem = (e) => this.toggleItem(e);

    // Get necessary elements
    this.accordionButtons = scope.querySelectorAll(".accordion__button");
    this.accordionButtonsLength = this.accordionButtons.length;
  }

  /**
   * Bind all event listeners to appropiate elemens
   */
  init() {
    for (let i = 0; i < this.accordionButtonsLength; i += 1) {
      const elem = this.accordionButtons[i];

      elem.addEventListener("click", this.boundToggleItem, false);
    }
  }

  /**
   * Show or hide the overlay menu
   */
  toggleItem(e: Event) {
    e.preventDefault();

    const button = e.currentTarget as HTMLAnchorElement;
    const parent = button.parentNode as HTMLDivElement;

    parent?.classList.toggle("-is-open");
  }
}
